:host(.pds-sortable) {
  display: flex;
  flex-direction: column;

  &.pds-sortable--bordered {
    border: var(--pine-border);
    border-radius: var(--pine-dimension-2xs)
  }
}
